import { render, staticRenderFns } from "./ProductRecommendDetail.vue?vue&type=template&id=30c9a413&scoped=true"
import script from "./ProductRecommendDetail.vue?vue&type=script&lang=js"
export * from "./ProductRecommendDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductRecommendDetail.vue?vue&type=style&index=0&id=30c9a413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9a413",
  null
  
)

export default component.exports